import { Component } from '@verndale/core';

class Input extends Component {
  setupDefaults() {
    this.dom = {
      $input: this.el._$('.field__input')
    };

    this.handleChange();
  }

  addListeners() {
    const { $input } = this.dom;

    $input._on('blur', ::this.handleBlur);
    $input._on('change', ::this.handleChange);
  }

  handleChange() {
    const { value } = this.dom.$input;

    if (value) {
      this.el.classList.add('field--filled');
      this.handleBlur();
    } else {
      this.el.classList.remove('field--filled');
    }
  }

  handleBlur() {
    this.el.classList.add('field--touched');
  }
}

export default Input;
